import { render } from "./VideoStylePanel.vue?vue&type=template&id=fe73b3a2&scoped=true&ts=true"
import script from "./VideoStylePanel.vue?vue&type=script&lang=ts"
export * from "./VideoStylePanel.vue?vue&type=script&lang=ts"

import "./VideoStylePanel.vue?vue&type=style&index=0&id=fe73b3a2&lang=scss&scoped=true"

import exportComponent from "E:\\Code\\Github\\Wuguojie-AviationTeach\\AviationTeach-PPT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe73b3a2"]])

export default __exports__